import { IAssortmentItem } from '../../../../features/assortment/models/data/IAssortmentItem'

interface IParams {
  entryId: number
  assortmentGroupId: number
}

export const createBlankAssortmentItem = ({
  entryId,
  assortmentGroupId,
}: IParams): IAssortmentItem => {
  return {
    EntryId: entryId,
    AssortmentGroupId: assortmentGroupId,
    Comments: '',
    Configs: '',
    Configurations: '',
    Focus: '',
    ProductCodeName: '',
    SortOrder: 1,
    Status: 'won',
    StatusText: '',
    Suppliers: '',
    Units: '',
    isChanged: true,
  }
}
